// @flow
export const STEPPER_THEME_API = {
  root: '',
  label: '',
  stepsWrapper: '',
  active: '',
  finished: '',
  disabled: ''
};
